import gql from "graphql-tag";

export default class QueryManufacture {
  public static getCarteManufacture() {
    return gql`
      query getCarteManufacture($language: String!, $id: Int!) {
        getCarteManufacture(defaultLanguage: $language, id: $id) {
          id
          name
          city
          description
          requiredByCitation {
            id
            citation
            description
          }
          requiredByImageArchive {
            id
            title
            creator
            description
            museum
            image {
              ... on asset {
                id
                fullpath
              }
            }
          }
          requiredByIndienne {
            id
            title
            creator
            description
            museum
            image {
              ... on asset {
                id
                fullpath
              }
            }
          }
        }
      }
    `;
  }
}
